module.exports = __webpack_public_path__ + "static/frame-b493bf9e2bb94aab34ca5a75c77ab14e.svg";